import { FC } from 'react'
import { Avatar, AvatarProps } from '@pogokid/mui'
import { abbreviate, strToColor } from '@pogokid/util'

function avatarPropsFromString(
  name: string,
  sx: AvatarProps['sx'] = {}
) {
  const { initials } = abbreviate(name)
  return {
    sx: {
      ...sx,
      bgcolor: strToColor(name),
    },
    children: initials.toUpperCase(),
  }
}

export const PersonAvatar: FC<Omit<AvatarProps, 'children'>> = ({
  alt,
  src,
  srcSet,
  ...props
}) => {
  if (src || srcSet) {
    return (
      <Avatar
        alt={alt}
        src={src}
        srcSet={srcSet}
        slotProps={{ img: { crossOrigin: 'anonymous' } }}
        {...props}
      />
    )
  } else {
    return (
      <Avatar {...avatarPropsFromString(alt || '?', props.sx)} />
    )
  }
}
